<template>
  <div class="statistics-background-blurr"
  :style="`width: calc(${project_length + 1} * (var(--workpackage_width) + 8px) * var(--taktplan_zoom)); `"
  >
    <slot
      :statistics="statistics"
      :current_takt_index="current_takt_index"
      :current_day_index="current_day_index"
      />
  </div>
</template>
<script>
export default {
  props: ['project_length', 'set_statistics_height', 'statistics', 'current_takt_index', 'current_day_index'],
  data: () => ({
  }),
}
</script>
<style>
  .statistics-background-blurr {
    height: var(--statistics_height);
    display: flex;
    /* background-color: rgba(255, 255, 255, .05); */
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    transition: height 300ms ease-in-out;
    overflow: auto;
  }
</style>
